import script from "./Adjustments.vue?vue&type=script&setup=true&lang=js"
export * from "./Adjustments.vue?vue&type=script&setup=true&lang=js"

import "./Adjustments.vue?vue&type=style&index=0&id=e29adca8&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e29adca8"]])

export default __exports__